import { render, staticRenderFns } from "./mpconfig.vue?vue&type=template&id=33a6cafa&"
import script from "./mpconfig.vue?vue&type=script&lang=js&"
export * from "./mpconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports